import { Injectable, inject } from '@angular/core';
import { SiaExternalSourcesApi } from '../apis/sia-external-sources-api';
import { RequestParams } from '../interfaces/request-params';

@Injectable({
  providedIn: 'root',
})
export class SiaExternalSourcesService {
  private api = inject(SiaExternalSourcesApi);

  protected serviceName: string = 'base';

  /** Inserted by Angular inject() migration for backwards compatibility */

  findCompaniesByParams(parameters: any) {
    return this.api.findCompaniesByParams(this.serviceName, parameters);
  }

  updateProfile(
    externalId: string | undefined,
    profileId: number,
    templateId: string | undefined,
    forceUpdate: boolean,
  ) {
    let requestParams: RequestParams = {
      externalId: externalId,
      templateId: templateId,
      forceUpdate: forceUpdate,
    };
    return this.api.updateProfile(this.serviceName, profileId, requestParams);
  }

  createNewProfile(
    externalId: string,
    countryId: string,
    prospectToCustomerDate: Date | null,
    templateId: string | undefined,
    force: boolean = false,
    vatNumber: string | undefined,
  ) {
    let requestParams: RequestParams = {
      externalId: externalId,
      countryId: countryId,
      prospectToCustomerDate: prospectToCustomerDate,
      templateId: templateId,
      forceUpdate: force,
      vatNumber: vatNumber,
    };
    return this.api.createNewProfile(this.serviceName, requestParams);
  }
  refreshProfile(profileId: number) {
    return this.api.refreshProfile(this.serviceName, profileId);
  }
  deleteRelation(profileId: number) {
    return this.api.deleteRelation(this.serviceName, profileId);
  }
  getStoredCompanyByProfile(profileId: number) {
    return this.api.getStoredCompanyByProfile(this.serviceName, profileId);
  }
  getTemplates(countryId: string) {
    return this.api.getTemplates(this.serviceName, countryId);
  }
  getTemplatesByProfileId(profileId: number) {
    return this.api.getTemplatesByProfileId(this.serviceName, profileId);
  }
  checkSavedFromId(profileId: number) {
    return this.api.checkSavedFromId(this.serviceName, profileId);
  }
}
